import React from 'react';
import styled from 'styled-components';
import {
  PieChart,
  Pie,
  Cell,
  ResponsiveContainer,
  Legend,
  Tooltip
} from 'recharts';
import { ChartCard } from './ChartCard';
import { colors } from '../../theme/tokens';
import {
  DEMO_SOURCE_TYPE_PREVIOUS,
  DEMO_SOURCE_TYPE_CURRENT
} from './demoData';

const DEMO_PREVIOUS = DEMO_SOURCE_TYPE_PREVIOUS;
const DEMO_CURRENT = DEMO_SOURCE_TYPE_CURRENT;

const COLORS = [colors.indigo, colors.olive, colors.amber, colors.crimson];

export const SourceTypeDistributionCard: React.FC = () => (
  <ChartCard
    title="Répartition par Type de Source"
    subtitle="Comparaison année précédente vs année en cours"
  >
    <Row>
      <HalfCol>
        <YearLabel>2025</YearLabel>
        <ChartWrap>
          <ResponsiveContainer width="100%" height={220}>
            <PieChart>
              <Pie
                data={DEMO_PREVIOUS}
                cx="50%"
                cy="50%"
                innerRadius={50}
                outerRadius={80}
                dataKey="value"
              >
                {DEMO_PREVIOUS.map((_, i) => (
                  <Cell key={i} fill={COLORS[i % COLORS.length]} />
                ))}
              </Pie>
              <Tooltip />
              <Legend />
            </PieChart>
          </ResponsiveContainer>
        </ChartWrap>
        <TopList>
          {DEMO_PREVIOUS.sort((a, b) => b.value - a.value).map((item, idx) => (
            <TopItem key={item.name}>
              <TopRank>#{idx + 1}</TopRank>
              <TopName>{item.name}</TopName>
              <TopValue>{item.value}</TopValue>
            </TopItem>
          ))}
        </TopList>
      </HalfCol>

      <HalfCol>
        <YearLabel>2026</YearLabel>
        <ChartWrap>
          <ResponsiveContainer width="100%" height={220}>
            <PieChart>
              <Pie
                data={DEMO_CURRENT}
                cx="50%"
                cy="50%"
                innerRadius={50}
                outerRadius={80}
                dataKey="value"
              >
                {DEMO_CURRENT.map((_, i) => (
                  <Cell key={i} fill={COLORS[i % COLORS.length]} />
                ))}
              </Pie>
              <Tooltip />
              <Legend />
            </PieChart>
          </ResponsiveContainer>
        </ChartWrap>
        <TopList>
          {DEMO_CURRENT.sort((a, b) => b.value - a.value).map((item, idx) => (
            <TopItem key={item.name}>
              <TopRank>#{idx + 1}</TopRank>
              <TopName>{item.name}</TopName>
              <TopValue>{item.value}</TopValue>
            </TopItem>
          ))}
        </TopList>
      </HalfCol>
    </Row>
  </ChartCard>
);

// --- Styled ---

const Row = styled.div`
  display: flex;
  gap: 24px;
  flex-wrap: wrap;
`;

const HalfCol = styled.div`
  flex: 1;
  min-width: 260px;
`;

const YearLabel = styled.h4`
  font-family: var(--font-sans-semibold, var(--font-sans));
  font-size: 14px;
  font-weight: 600;
  color: var(--ink);
  text-align: center;
  margin: 0 0 8px;
`;

const ChartWrap = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

const TopList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  margin-top: 12px;
`;

const TopItem = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 6px 10px;
  background: var(--paper);
  border: 1px solid var(--line);
  border-radius: var(--radius-sm);
`;

const TopRank = styled.span`
  font-family: var(--font-mono);
  font-size: 11px;
  font-weight: 600;
  color: var(--ink-faint);
  min-width: 24px;
`;

const TopName = styled.span`
  font-family: var(--font-sans);
  font-size: 13px;
  font-weight: 500;
  color: var(--ink);
  flex: 1;
`;

const TopValue = styled.span`
  font-family: var(--font-mono);
  font-size: 12px;
  color: var(--ink-muted);
`;
